import { cutToast } from 'utility/toast';
import React from 'react';

import { useMutation } from '@apollo/client';
import {
  CreateMessageData,
  CreateNewMessage,
} from 'common/components/CreateNewMessage';
import {
  NewMessageApprovalCreate,
  NewMessageApprovalCreateVariables,
} from './__generated__/NewMessageApprovalCreate';
import { PivotKeys } from 'common/components/MessagesSections';

import ADD_NEW_MESSAGE from './NewMessageApprovalCreate.graphql';
import GET_EMPLOYEE_USER_MESSAGE from '../GetApprovalMessage.graphql';
interface CreateNewMessageViewProps {
  selectedKey: string;
  invoiceID: string;
  onCreateMessage: () => void;
}

export const NewMessage: React.FC<CreateNewMessageViewProps> = ({
  invoiceID,
  selectedKey,
  onCreateMessage,
}) => {
  const [createMessage, { loading }] = useMutation<
    NewMessageApprovalCreate,
    NewMessageApprovalCreateVariables
  >(ADD_NEW_MESSAGE);

  const onSubmit = async (formData: CreateMessageData) => {
    const { messageComment, reminderDates, isResponseRequired, receivers } = {
      ...formData,
    };
    const messageFilter =
      selectedKey === PivotKeys.sent
        ? { _isOutgoingMessage: { equalTo: true } }
        : { _isIncomingMessage: { equalTo: true } };
    const { communicationChannel, department, user } = { ...receivers };
    const { errors } = await createMessage({
      variables: {
        input: {
          entityId: invoiceID,
          message: { messageComment, reminderDates, isResponseRequired },
          communicationChannel,
          department,
          user,
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GET_EMPLOYEE_USER_MESSAGE,
          variables: {
            id: invoiceID,
            first: 10,
            filter: messageFilter,
          },
        },
      ],
    });

    if (!errors) {
      onCreateMessage();
      cutToast.success('Message sent successfully.');
    } else cutToast.error(`${errors[0].message}`);
  };

  return <CreateNewMessage onSubmit={onSubmit} loading={loading} />;
};
